// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Formality from "../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Result from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingUtils from "../../../library/utils/CorePricingUtils.bs.js";
import * as CorePricingContext from "../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PricingDashboardConfig from "../../../library/utils/PricingDashboardConfig.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as FomDateInputTs$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FomDateInputTs.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";

var validators_free_km_price = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.free_km_price
                    }), (function (price) {
                    if (price < 0.0 || price > PricingDashboardConfig.free_km_price_lmit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 25"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Currency.toCurrency(price)
                            };
                    }
                  }));
    })
};

var validators_free_kms = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(CorePricingUtils.getIntValue(param.free_kms), (function (kms) {
                    if (kms < 0 || kms > PricingDashboardConfig.free_kms_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 20"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: kms
                            };
                    }
                  }));
    })
};

var validators_waiting_rate_per_min = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.waiting_rate_per_min
                    }), (function (rate) {
                    if (rate < 0.0 || rate > PricingDashboardConfig.waiting_rate_per_min_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 25"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Currency.toCurrency(rate)
                            };
                    }
                  }));
    })
};

var validators_free_duration = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(CorePricingUtils.getIntValue(param.free_duration), (function (duration) {
                    if (duration < 0 || duration > PricingDashboardConfig.free_duration_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 300"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: duration
                            };
                    }
                  }));
    })
};

var validators_base_fare = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.base_fare
                    }), (function (fare) {
                    if (fare < 0.0 || fare > PricingDashboardConfig.base_fare_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 3000"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Currency.toCurrency(fare)
                            };
                    }
                  }));
    })
};

var validators_start_date = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var start_date = param.start_date;
      if (start_date !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.valFromOption(start_date)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Start date is required"
              };
      }
    })
};

var validators_campaign_name = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.campaign_name
                    }), (function (campaign_name) {
                    if (campaign_name.length > 60) {
                      return {
                              TAG: /* Error */1,
                              _0: "Campaign Names cannot be more than 60 characters"
                            };
                    } else if (campaign_name.length < 3) {
                      return {
                              TAG: /* Error */1,
                              _0: "Campaign Names cannot be less than 3 characters"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: campaign_name
                            };
                    }
                  }));
    })
};

var validators = {
  free_km_price: validators_free_km_price,
  free_kms: validators_free_kms,
  waiting_rate_per_min: validators_waiting_rate_per_min,
  free_duration: validators_free_duration,
  base_fare: validators_base_fare,
  start_date: validators_start_date,
  campaign_name: validators_campaign_name,
  vehicle: undefined,
  region: undefined
};

function initialFieldsStatuses(_input) {
  return {
          free_km_price: /* Pristine */0,
          free_kms: /* Pristine */0,
          waiting_rate_per_min: /* Pristine */0,
          free_duration: /* Pristine */0,
          base_fare: /* Pristine */0,
          start_date: /* Pristine */0,
          campaign_name: /* Pristine */0,
          vehicle: /* Pristine */0,
          region: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.free_km_price;
  var match_0 = match ? match._0 : Curry._1(validators.free_km_price.validate, input);
  var match$1 = fieldsStatuses.free_kms;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.free_kms.validate, input);
  var match$2 = fieldsStatuses.waiting_rate_per_min;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.waiting_rate_per_min.validate, input);
  var match$3 = fieldsStatuses.free_duration;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.free_duration.validate, input);
  var match$4 = fieldsStatuses.base_fare;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.base_fare.validate, input);
  var match$5 = fieldsStatuses.start_date;
  var match_0$5 = match$5 ? match$5._0 : Curry._1(validators.start_date.validate, input);
  var match$6 = fieldsStatuses.campaign_name;
  var match_0$6 = match$6 ? match$6._0 : Curry._1(validators.campaign_name.validate, input);
  var match_0$7 = {
    TAG: /* Ok */0,
    _0: input.vehicle
  };
  var match_0$8 = {
    TAG: /* Ok */0,
    _0: input.region
  };
  var free_km_priceResult = match_0;
  var free_km_priceResult$1;
  if (free_km_priceResult.TAG === /* Ok */0) {
    var free_kmsResult = match_0$1;
    if (free_kmsResult.TAG === /* Ok */0) {
      var waiting_rate_per_minResult = match_0$2;
      if (waiting_rate_per_minResult.TAG === /* Ok */0) {
        var free_durationResult = match_0$3;
        if (free_durationResult.TAG === /* Ok */0) {
          var base_fareResult = match_0$4;
          if (base_fareResult.TAG === /* Ok */0) {
            var start_dateResult = match_0$5;
            if (start_dateResult.TAG === /* Ok */0) {
              var campaign_nameResult = match_0$6;
              if (campaign_nameResult.TAG === /* Ok */0) {
                var vehicleResult = match_0$7;
                if (vehicleResult.TAG === /* Ok */0) {
                  var regionResult = match_0$8;
                  if (regionResult.TAG === /* Ok */0) {
                    return {
                            TAG: /* Valid */0,
                            output: {
                              region: regionResult._0,
                              vehicle: vehicleResult._0,
                              campaign_name: campaign_nameResult._0,
                              start_date: start_dateResult._0,
                              base_fare: base_fareResult._0,
                              free_duration: free_durationResult._0,
                              waiting_rate_per_min: waiting_rate_per_minResult._0,
                              free_kms: free_kmsResult._0,
                              free_km_price: free_km_priceResult._0
                            },
                            fieldsStatuses: {
                              free_km_price: /* Dirty */{
                                _0: free_km_priceResult,
                                _1: /* Shown */0
                              },
                              free_kms: /* Dirty */{
                                _0: free_kmsResult,
                                _1: /* Shown */0
                              },
                              waiting_rate_per_min: /* Dirty */{
                                _0: waiting_rate_per_minResult,
                                _1: /* Shown */0
                              },
                              free_duration: /* Dirty */{
                                _0: free_durationResult,
                                _1: /* Shown */0
                              },
                              base_fare: /* Dirty */{
                                _0: base_fareResult,
                                _1: /* Shown */0
                              },
                              start_date: /* Dirty */{
                                _0: start_dateResult,
                                _1: /* Shown */0
                              },
                              campaign_name: /* Dirty */{
                                _0: campaign_nameResult,
                                _1: /* Shown */0
                              },
                              vehicle: /* Dirty */{
                                _0: vehicleResult,
                                _1: /* Hidden */1
                              },
                              region: /* Dirty */{
                                _0: regionResult,
                                _1: /* Hidden */1
                              }
                            },
                            collectionsStatuses: undefined
                          };
                  }
                  free_km_priceResult$1 = free_km_priceResult;
                } else {
                  free_km_priceResult$1 = free_km_priceResult;
                }
              } else {
                free_km_priceResult$1 = free_km_priceResult;
              }
            } else {
              free_km_priceResult$1 = free_km_priceResult;
            }
          } else {
            free_km_priceResult$1 = free_km_priceResult;
          }
        } else {
          free_km_priceResult$1 = free_km_priceResult;
        }
      } else {
        free_km_priceResult$1 = free_km_priceResult;
      }
    } else {
      free_km_priceResult$1 = free_km_priceResult;
    }
  } else {
    free_km_priceResult$1 = free_km_priceResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            free_km_price: /* Dirty */{
              _0: free_km_priceResult$1,
              _1: /* Shown */0
            },
            free_kms: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            waiting_rate_per_min: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            free_duration: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            base_fare: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            start_date: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            campaign_name: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            vehicle: /* Dirty */{
              _0: match_0$7,
              _1: /* Hidden */1
            },
            region: /* Dirty */{
              _0: match_0$8,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurFree_km_priceField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.free_km_price, validators_free_km_price, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: status,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFree_kmsField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.free_kms, validators_free_kms, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: status,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurWaiting_rate_per_minField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.waiting_rate_per_min, validators_waiting_rate_per_min, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: status,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFree_durationField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.free_duration, validators_free_duration, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: status,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurBase_fareField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.base_fare, validators_base_fare, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: status,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_dateField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.start_date, validators_start_date, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: status,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCampaign_nameField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.campaign_name, validators_campaign_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: status,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurVehicleField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithoutValidator(state.input.vehicle, state.fieldsStatuses.vehicle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: status,
                                  region: init.region
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRegionField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithoutValidator(state.input.region, state.fieldsStatuses.region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare,
                                  start_date: init.start_date,
                                  campaign_name: init.campaign_name,
                                  vehicle: init.vehicle,
                                  region: status
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */9 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */9,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */10,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */12);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */11);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */10 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */11 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */12 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateFree_km_priceField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.free_km_price, state.submissionStatus, validators_free_km_price, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: status,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFree_kmsField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.free_kms, state.submissionStatus, validators_free_kms, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: status,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateWaiting_rate_per_minField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.waiting_rate_per_min, state.submissionStatus, validators_waiting_rate_per_min, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: status,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFree_durationField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.free_duration, state.submissionStatus, validators_free_duration, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: status,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateBase_fareField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.base_fare, state.submissionStatus, validators_base_fare, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: status,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_dateField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, state.fieldsStatuses.start_date, state.submissionStatus, validators_start_date, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: status,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCampaign_nameField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$6, state.fieldsStatuses.campaign_name, state.submissionStatus, validators_campaign_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: status,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateVehicleField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$7.vehicle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: status,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRegionField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$8.region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare,
                                            start_date: init.start_date,
                                            campaign_name: init.campaign_name,
                                            vehicle: init.vehicle,
                                            region: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */9 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */10 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */11 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateFree_km_price: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFree_km_priceField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFree_kms: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFree_kmsField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateWaiting_rate_per_min: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateWaiting_rate_per_minField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFree_duration: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFree_durationField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateBase_fare: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateBase_fareField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_date: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_dateField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCampaign_name: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCampaign_nameField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateVehicle: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicleField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateRegion: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRegionField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurFree_km_price: (function (param) {
              return Curry._1(dispatch, /* BlurFree_km_priceField */0);
            }),
          blurFree_kms: (function (param) {
              return Curry._1(dispatch, /* BlurFree_kmsField */1);
            }),
          blurWaiting_rate_per_min: (function (param) {
              return Curry._1(dispatch, /* BlurWaiting_rate_per_minField */2);
            }),
          blurFree_duration: (function (param) {
              return Curry._1(dispatch, /* BlurFree_durationField */3);
            }),
          blurBase_fare: (function (param) {
              return Curry._1(dispatch, /* BlurBase_fareField */4);
            }),
          blurStart_date: (function (param) {
              return Curry._1(dispatch, /* BlurStart_dateField */5);
            }),
          blurCampaign_name: (function (param) {
              return Curry._1(dispatch, /* BlurCampaign_nameField */6);
            }),
          blurVehicle: (function (param) {
              return Curry._1(dispatch, /* BlurVehicleField */7);
            }),
          blurRegion: (function (param) {
              return Curry._1(dispatch, /* BlurRegionField */8);
            }),
          free_km_priceResult: Formality.exposeFieldResult(state.fieldsStatuses.free_km_price),
          free_kmsResult: Formality.exposeFieldResult(state.fieldsStatuses.free_kms),
          waiting_rate_per_minResult: Formality.exposeFieldResult(state.fieldsStatuses.waiting_rate_per_min),
          free_durationResult: Formality.exposeFieldResult(state.fieldsStatuses.free_duration),
          base_fareResult: Formality.exposeFieldResult(state.fieldsStatuses.base_fare),
          start_dateResult: Formality.exposeFieldResult(state.fieldsStatuses.start_date),
          campaign_nameResult: Formality.exposeFieldResult(state.fieldsStatuses.campaign_name),
          vehicleResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle),
          regionResult: Formality.exposeFieldResult(state.fieldsStatuses.region),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.free_km_price || match.free_kms || match.waiting_rate_per_min || match.free_duration || match.base_fare || match.start_date || match.campaign_name || match.vehicle || match.region) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */9);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */10);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */11);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */11,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */12);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialState(base_details, active_campaign, region, vehicle) {
  if (base_details !== undefined) {
    return {
            region: region,
            vehicle: vehicle,
            campaign_name: base_details.campaign_name,
            start_date: Caml_option.some(base_details.start_date),
            base_fare: Currency.toString(base_details.base_fare),
            free_duration: String(base_details.free_duration),
            waiting_rate_per_min: Currency.toString(base_details.waiting_rate_per_min),
            free_kms: String(base_details.free_kms),
            free_km_price: Currency.toString(base_details.free_km_price)
          };
  }
  if (active_campaign === undefined) {
    return {
            region: region,
            vehicle: vehicle,
            campaign_name: "",
            start_date: undefined,
            base_fare: "",
            free_duration: "",
            waiting_rate_per_min: "",
            free_kms: "",
            free_km_price: ""
          };
  }
  var campaign_info = active_campaign[0];
  return {
          region: region,
          vehicle: vehicle,
          campaign_name: "",
          start_date: undefined,
          base_fare: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(campaign_info.fare_details.base_fare)),
          free_duration: String(CorePricingUtils.fromMilliSecToMins(campaign_info.fare_details.free_duration)),
          waiting_rate_per_min: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(campaign_info.fare_details.waiting_rate_per_min)),
          free_kms: String(campaign_info.fare_details.free_slab.free_kms),
          free_km_price: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(campaign_info.fare_details.free_slab.price_per_min))
        };
}

function isStartDateInvalid(start_date, restricted_dates) {
  if (start_date === undefined) {
    return false;
  }
  var input_date = Caml_option.valFromOption(start_date);
  return List.exists((function (restricted_date) {
                return Timestamp$Catalyst.toString(restricted_date, "DD-MM-YYYY") === Timestamp$Catalyst.toString(input_date, "DD-MM-YYYY");
              }), restricted_dates);
}

function BaseDetailsForm(Props) {
  var base_details = Props.base_details;
  var restricted_dates = Props.restricted_dates;
  var active_campaign = Props.active_campaign;
  var onNext = Props.onNext;
  var onBack = Props.onBack;
  var match = CorePricingContext.useContext(undefined);
  var vehicle_name = match.vehicle_type.vehicle_name;
  var geo_region_name = match.geo_region.geo_region_name;
  var form = useForm(getInitialState(base_details, active_campaign, geo_region_name, vehicle_name), (function (output, param) {
          return Curry._1(onNext, {
                      region: geo_region_name,
                      vehicle: vehicle_name,
                      campaign_name: output.campaign_name,
                      start_date: output.start_date,
                      base_fare: output.base_fare,
                      free_duration: output.free_duration,
                      waiting_rate_per_min: output.waiting_rate_per_min,
                      free_kms: output.free_kms,
                      free_km_price: output.free_km_price
                    });
        }));
  var match$1 = React.useState(function () {
        return false;
      });
  var set_is_start_date_invalid = match$1[1];
  var is_start_date_invalid = match$1[0];
  React.useEffect((function () {
          Curry._1(set_is_start_date_invalid, (function (param) {
                  return isStartDateInvalid(form.input.start_date, restricted_dates);
                }));
          
        }), [form.input.start_date]);
  var match$2 = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match$2.country);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "base-details-container"
                }, React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Geolocation"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.region
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Vehicle ID"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Geolocation and Vehicle ID have been preset due to the filters applied."
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.vehicle
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Campaign Name"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateCampaign_name, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: value,
                                                        start_date: input.start_date,
                                                        base_fare: input.base_fare,
                                                        free_duration: input.free_duration,
                                                        waiting_rate_per_min: input.waiting_rate_per_min,
                                                        free_kms: input.free_kms,
                                                        free_km_price: input.free_km_price
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.campaign_nameResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Campaign Names cannot be more than 60 characters"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.campaign_name
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Effective From"), React.createElement(FomDateInputTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, is_start_date_invalid ? ({
                                    TAG: /* Error */1,
                                    _0: "Campaign already scheduled/pending for this date"
                                  }) : form.start_dateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          date_props: FomDateInputTs$Catalyst.make_props(form.input.start_date, Caml_option.some(Timestamp$Catalyst.tomorrow(undefined)), Caml_option.some(Timestamp$Catalyst.getDateTimeAfterElapsedTime(180.0, /* Days */4, Timestamp$Catalyst.tomorrow(undefined))), (function (date) {
                                  return Curry._2(form.updateStart_date, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: input.campaign_name,
                                                        start_date: value,
                                                        base_fare: input.base_fare,
                                                        free_duration: input.free_duration,
                                                        waiting_rate_per_min: input.waiting_rate_per_min,
                                                        free_kms: input.free_kms,
                                                        free_km_price: input.free_km_price
                                                      };
                                              }), Caml_option.some(date));
                                }), "DD/MM/YYYY", undefined, undefined, undefined, undefined)
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "Base Fare",
                          unit: currency
                        }), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateBase_fare, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: input.campaign_name,
                                                        start_date: input.start_date,
                                                        base_fare: value,
                                                        free_duration: input.free_duration,
                                                        waiting_rate_per_min: input.waiting_rate_per_min,
                                                        free_kms: input.free_kms,
                                                        free_km_price: input.free_km_price
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.base_fareResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter values between 0 and 3000"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.base_fare
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "Free Duration",
                          unit: "min"
                        }), React.createElement("div", {
                          className: "label"
                        }, ""), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateFree_duration, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: input.campaign_name,
                                                        start_date: input.start_date,
                                                        base_fare: input.base_fare,
                                                        free_duration: value,
                                                        waiting_rate_per_min: input.waiting_rate_per_min,
                                                        free_kms: input.free_kms,
                                                        free_km_price: input.free_km_price
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.free_durationResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter values between 0 and 300"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.free_duration
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "Waiting Rate per minute",
                          unit: currency + "/min"
                        }), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateWaiting_rate_per_min, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: input.campaign_name,
                                                        start_date: input.start_date,
                                                        base_fare: input.base_fare,
                                                        free_duration: input.free_duration,
                                                        waiting_rate_per_min: value,
                                                        free_kms: input.free_kms,
                                                        free_km_price: input.free_km_price
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.waiting_rate_per_minResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter values between 0 and 25"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.waiting_rate_per_min
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "Free KMS",
                          unit: "km"
                        }), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateFree_kms, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: input.campaign_name,
                                                        start_date: input.start_date,
                                                        base_fare: input.base_fare,
                                                        free_duration: input.free_duration,
                                                        waiting_rate_per_min: input.waiting_rate_per_min,
                                                        free_kms: value,
                                                        free_km_price: input.free_km_price
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.free_kmsResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter values between 0 and 20"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.free_kms
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "Price per minute for free KM",
                          unit: currency
                        }), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateFree_km_price, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        campaign_name: input.campaign_name,
                                                        start_date: input.start_date,
                                                        base_fare: input.base_fare,
                                                        free_duration: input.free_duration,
                                                        waiting_rate_per_min: input.waiting_rate_per_min,
                                                        free_kms: input.free_kms,
                                                        free_km_price: value
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.free_km_priceResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Enter values between 0 and 25"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.free_km_price
                          }
                        }))), React.createElement("div", {
                  className: "create-campaign-footer base-details-footer"
                }, React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Cancel"
                          }, undefined, (function (_event) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Next"
                          }, !Curry._1(form.valid, undefined), (function (_event) {
                              if (is_start_date_invalid) {
                                return ;
                              } else {
                                return Curry._1(form.submit, undefined);
                              }
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn " + (
                            Curry._1(form.valid, undefined) ? "" : "e-disabled-btn"
                          ), undefined, undefined)
                    })));
}

var make = BaseDetailsForm;

export {
  Form ,
  getInitialState ,
  isStartDateInvalid ,
  make ,
  
}
/* react Not a pure module */
